// eslint-disable-next-line import/prefer-default-export
export const UI_STATE_MAP = {
  noneActive: 'noneActive',
  annotationToolbar: 'annotationToolbar',
  postCommentPopover: 'postCommentPopover',
  postSuggestionPopover: 'postSuggestionPopover',
  aiAssistPopover: 'aiAssistPopover',
  saveChangesModal: 'saveChangesModal',
} as const;
